import { BaseColumnSelectionModel } from 'src/app/shared/import/base-column-selection-model';
import { ColumnForSelection } from '../../../shared/import/column-for-selection';
import { VarianceFormulaBaseLine } from './variance-formula-baseline';

export enum RefVolumeBasis {
    OldColumnValue = 0,
    AverageColumnValue = 1,
}

export enum FormulaItemType {
    Other,
    OldFormComp,
    NewFormComp,
}

export class FormulaItem {
    formCompIx: number | null;
    type: FormulaItemType;
    text: string;
};
 
export class FormCompVarianceLine {
    formCompIx: number;
    formCompName: string;
    newFormulaPart: FormulaItem[];
    oldFormulaPart: FormulaItem[];
};

export class CalcOptionsModel extends BaseColumnSelectionModel {
    public varianceFormulaBaseLine: VarianceFormulaBaseLine;

    public oldBaseLine: FormCompVarianceLine[] | null;
    public newBaseLine: FormCompVarianceLine[] | null;
    public canonical: FormCompVarianceLine[] | null;

    public oldControlValue: string;
    public newControlValue: string;
}

export class RelativeImpactOptionsModel extends BaseColumnSelectionModel {
    public basis: RefVolumeBasis;
    public maxPerc: number;

    public columns: ColumnForSelection[];
    public outcomeName: string;
    public oldControlValue: string;
    public newControlValue: string;
}
